export type TODataGuid = string | { _value: string };

export function normalizeId(id: TODataGuid): string {
    if (!id) return null;
    if (typeof id === 'object') {
        return id._value || null;
    }
    return id || null;
}